export default __webpack_public_path__ + "static/media/pets.f4ebe791.pdf";